import { render, staticRenderFns } from "./CocktailMenu.vue?vue&type=template&id=bceb5c72"
import script from "./CocktailMenu.vue?vue&type=script&lang=js"
export * from "./CocktailMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports